export function incidentDisplayCode(incident: {
  code?: string | null;
  id: string;
}): string {
  const code = incident.code?.trim();
  return code && code.length > 0 ? code : incident.id;
}
